import account_service from '@/store/services/account-service';
import router from '@/router/index';

const token = localStorage.getItem('token');

const state = token ? {status: {loggedIn: true, working: false}, token: token}
                    : {status: {loggedIn: false, working: false}, token: null};

const actions = {

  login({dispatch, commit}, token) {
    commit('loginRequest');
    account_service.login(token)
      .then(
        token => {
          commit('loginSuccess', token);
          router.push('/');
          setTimeout(() => {
            dispatch('alert/success', 'Login successful.', {root: true});
          })
        },
        error => {
          commit('loginFailure', error);
          setTimeout(() => {
            if (error.response.status === 401 || error.response.status === 403)
              dispatch('alert/error', error.response.data.message, {root: true});
            else
              dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          });
        }
      );
  },

  logout({dispatch, commit}, token) {
    commit('logoutRequest');
    account_service.logout(token)
      .then(token => {
          commit('logoutSuccess', token);
          router.push('/authentication/login');
          setTimeout(() => {
            dispatch('alert/success', 'You have signed out.', {root: true});
          });
        },
        error => {
          commit('logoutFailure', error);
          setTimeout(() => {
            dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          })
        }
      );
  },

  register({dispatch, commit}, user) {
    commit('registerRequest');
    account_service.register(user)
      .then(
        () => {
          commit('registerSuccess');
          router.push('/authentication/login');
          setTimeout(() => {
            dispatch('alert/success', 'Registration successful.', {root: true});
          })
        },
        error => {
          commit('registerFailure', error);
          setTimeout(() => {
            dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          })
        }
      );
  },

  recover({dispatch, commit}, user) {
    commit('recoverRequest');
    account_service.recover(user)
      .then(
        () => {
          commit('recoverSuccess');
          router.push('/authentication/login');
          setTimeout(() => {
            dispatch('alert/success', 'Recovery link sent.', {root: true});
          })
        },
        error => {
          commit('recoverFailure', error);
          setTimeout(() => {
            dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          });
        }
      );
  },

  reset({dispatch, commit}, user) {
    account_service.reset(user)
      .then(
        () => {
          commit('resetSuccess');
          router.push('/authentication/login');
          setTimeout(() => {
            dispatch('alert/success', 'Password updated.', {root: true});
          })
        },
        error => {
          commit('resetFailure', error);
          setTimeout(() => {
            dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          });
        }
      );
  },

  expire({dispatch, commit}, token) {
    account_service.logout(token)
      .then(token => {
          commit('logoutRequest', token);
          router.push('/authentication/login');
          setTimeout(() => {
            dispatch('alert/error', 'Your session expired! 😟', {root: true});
          });
        },
        error => {
          commit('logoutFailure', error);
          setTimeout(() => {
            dispatch('alert/error', 'Oops, something went wrong.', {root: true});
          })
        }
      );
  }

};

const mutations = {
  loginRequest(state) {
    state.status = {loggedIn: false, working: true};
    state.token = null;
  },
  loginSuccess(state, token) {
    state.status = {loggedIn: true, working: false};
    state.token = token;
  },
  loginFailure(state, error) {
    state.status = {loggedIn: false, working: false};
    state.token = null;
    console.log(error);
  },
  registerRequest(state) {
    state.status.working = true;
  },
  registerSuccess(state) {
    state.status.working = false;
  },
  registerFailure(state, error) {
    state.status.working = false;
    console.log(error);
  },
  recoverRequest(state) {
    state.status.working = true;
  },
  recoverSuccess(state) {
    state.status.working = false;
  },
  recoverFailure(state, error) {
    state.status.working = false;
    console.log(error);
  },
  resetSuccess(state) {
    state.status = {};
  },
  resetFailure(state, error) {
    state.status = {};
    console.log(error);
  },
  logoutRequest(state) {
    state.status.working = true;
  },
  logoutSuccess(state) {
    state.status = {loggedIn: false, working:false};
    state.token = null;
  },
  logoutFailure(state, error) {
    state.status.working = false;
    console.log(error);
  }
};

const getters = {
  account(state) {
    return state;
  },
};

const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

export default account;
